const HOSTS = {
  development: 'https://www.opendoor.com',
  test: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  production: 'https://www.opendoor.com',
} as const;

// The seller flow lives on the consumer app; the address handoff redirects here
// (consumer.<env>/seller-lead/<uuid>), matching the production homepage flow.
const CONSUMER_HOSTS = {
  development: 'https://consumer.opendoor.com',
  test: 'https://consumer.opendoor.com',
  staging: 'https://consumer.simplersell.com',
  production: 'https://consumer.opendoor.com',
} as const;

type DeployEnv = keyof typeof HOSTS;

function isDeployEnv(env: string): env is DeployEnv {
  return Object.hasOwn(HOSTS, env);
}

function currentEnv(): DeployEnv {
  const env = process.env.NEXT_PUBLIC_DEPLOY_ENV;
  return env && isDeployEnv(env) ? env : 'development';
}

export const OPENDOOR_HOST = HOSTS[currentEnv()];
export const CONSUMER_HOST = CONSUMER_HOSTS[currentEnv()];

export function opendoorUrl(path: string): string {
  if (!path.startsWith('/')) {
    throw new Error(`opendoorUrl path must start with "/", got: ${path}`);
  }
  return `${OPENDOOR_HOST}${path}`;
}

export function consumerUrl(path: string): string {
  if (!path.startsWith('/')) {
    throw new Error(`consumerUrl path must start with "/", got: ${path}`);
  }
  return `${CONSUMER_HOST}${path}`;
}
